import { FailureType } from './shared/types';
import { error$ } from './observables/error';
async function invoke(method, data = {}, signal) {
    return fetch(`/api/${method}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
        ...(signal ? { signal } : {})
    })
        .then(resp => {
        if (!resp.ok) {
            return resp.json().then(error => {
                const message = 'message' in error ? error.message : String(error);
                error$.next({ type: FailureType.APIError, message, method });
            });
        }
        return resp.json();
    })
        .catch(e => {
        process.env.NODE_ENV == 'development' && console.error(`/api/${method}`, e);
    });
}
const channels = new Map;
const ws = new WebSocket(`ws://${location.host}/events`);
ws.onmessage = ({ data }) => {
    const event = JSON.parse(data);
    if (event && typeof event == 'object' && 'channel' in event) {
        (channels.get(event['channel']) ?? []).forEach(callback => callback(event));
    }
};
let reload;
ws.onclose = (e) => {
    clearTimeout(reload);
    console.debug('Disconnected. Reloading...');
    reload = setTimeout(() => window.location.reload(), 2000);
};
function subscribe(channel, callback) {
    const callbacks = channels.get(channel);
    channels.set(channel, callbacks ? [...callbacks, callback] : [callback]);
}
window.f5 = {
    settings: () => invoke('getapp'),
    saveSettings: (settings) => invoke('saveapp', { settings }),
    onError: listener => subscribe('error', (error) => listener(error)),
    connect: (file, signal) => invoke('connect', { file }, signal),
    login: (id, password, remember) => invoke('login', { id, password, remember }),
    disconnect: (id, sid) => invoke('disconnect', { id, sid }),
    watch: dir => invoke('watch', { dir }),
    unwatch: dir => invoke('unwatch', { dir }),
    refresh: dir => invoke('refresh', { dir }),
    onDirChange: listener => subscribe('dir', ({ uri, files }) => listener(uri, files)),
    onFileChange: listener => subscribe('file', ({ path, stat }) => listener(path, stat)),
    copy: (src, dest, move = false, filter, root, sid) => invoke('copy', { src, dest, move, filter, root, sid }),
    duplicate: (src, filter) => invoke('duplicate', { src, filter }),
    remove: (files) => invoke('remove', { files }),
    clear: (file) => invoke('clear', { file }),
    open: (file, app) => invoke('open', { file, app }),
    mkdir: (name, parent) => invoke('mkdir', { name, parent }),
    read: (file) => invoke('read', { file }),
    write: (path, content) => invoke('write', { path, content }),
    rename: (path, name) => invoke('rename', { path, name }),
    get: (path) => invoke('get', { path }),
    save: (path, settings) => invoke('save', { path, settings }),
    resolve: (id, action, forAll, sid) => invoke('resolve', { id, action, forAll, sid }),
    stop: id => invoke('stop', { id }),
    onQueueUpdate: listener => subscribe('queue', ({ id, event }) => listener(id, event)),
    mirror: (local, remote, sid, recursive, del, filter) => invoke('mirror', { local, remote, sid, recursive, del, filter }),
    unmirror: (id) => invoke('unmirror', { id }),
    onMirrorUpdate: listener => subscribe('mirror', (event) => listener(event)),
};
window.f5.onError((error) => error$.next(error));
